import { render, staticRenderFns } from "./DetailCamsSetting.vue?vue&type=template&id=01efcc6d"
import script from "./DetailCamsSetting.vue?vue&type=script&lang=js"
export * from "./DetailCamsSetting.vue?vue&type=script&lang=js"
import style0 from "./DetailCamsSetting.vue?vue&type=style&index=0&id=01efcc6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VList,VListItem,VListItemTitle,VMenu,VTab,VTabs})
